import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
import { convertThreshold } from 'z3k-parser/model/z3k-config/sensors/utils';
export var RadioSensorValue;
(function (RadioSensorValue) {
    RadioSensorValue[RadioSensorValue["TEMPERATURE"] = 0] = "TEMPERATURE";
    RadioSensorValue[RadioSensorValue["HUMIDITY"] = 1] = "HUMIDITY";
    RadioSensorValue[RadioSensorValue["BATTERY_LEVEL"] = 2] = "BATTERY_LEVEL";
    RadioSensorValue[RadioSensorValue["RSSI"] = 3] = "RSSI";
})(RadioSensorValue || (RadioSensorValue = {}));
export var RadioSensor;
(function (RadioSensor) {
    let Type;
    (function (Type) {
        Type[Type["DEFAULT"] = 0] = "DEFAULT";
        Type[Type["RADIO_FOB_3_BUTTONS_TYPE"] = 2] = "RADIO_FOB_3_BUTTONS_TYPE";
        Type[Type["RADIO_FOB_4_BUTTONS_TYPE"] = 3] = "RADIO_FOB_4_BUTTONS_TYPE";
        Type[Type["TEMPERATURE_A"] = 5] = "TEMPERATURE_A";
        Type[Type["TEMPERATURE_B"] = 15] = "TEMPERATURE_B";
        Type[Type["TEMPERATURE_C"] = 16] = "TEMPERATURE_C";
        Type[Type["LEAK"] = 10] = "LEAK";
        Type[Type["MOTION"] = 11] = "MOTION";
        Type[Type["HUMIDITY"] = 18] = "HUMIDITY";
        Type[Type["RADIO_DISPLAY_TEMPERATURE"] = 23] = "RADIO_DISPLAY_TEMPERATURE";
        Type[Type["RADIO_RELAY"] = 255] = "RADIO_RELAY";
    })(Type = RadioSensor.Type || (RadioSensor.Type = {}));
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["NO_CONNECT_FLAG"] = 1] = "NO_CONNECT_FLAG";
        StatusFlags[StatusFlags["IS_TRIGGERED_FLAG"] = 2] = "IS_TRIGGERED_FLAG";
        StatusFlags[StatusFlags["IS_UPPER_THRES_FLAG"] = 4] = "IS_UPPER_THRES_FLAG";
        StatusFlags[StatusFlags["NO_CONNECT_EVENT_FLAG"] = 16] = "NO_CONNECT_EVENT_FLAG";
        StatusFlags[StatusFlags["LEAK_FLAG"] = 32] = "LEAK_FLAG";
        StatusFlags[StatusFlags["MOTION_FLAG"] = 64] = "MOTION_FLAG";
        StatusFlags[StatusFlags["IS_TEMP_TRIGGERED_FLAG"] = 128] = "IS_TEMP_TRIGGERED_FLAG";
        StatusFlags[StatusFlags["IS_HIMID_TRIGGERED_FLAG"] = 256] = "IS_HIMID_TRIGGERED_FLAG";
        StatusFlags[StatusFlags["GUARD_FLAG"] = 512] = "GUARD_FLAG";
        StatusFlags[StatusFlags["IS_UPPER_THRES_HUMID_FLAG"] = 1024] = "IS_UPPER_THRES_HUMID_FLAG";
        StatusFlags[StatusFlags["IS_FOB_GUARD_ON_BUTTON_PRESSED"] = 2048] = "IS_FOB_GUARD_ON_BUTTON_PRESSED";
        StatusFlags[StatusFlags["IS_FOB_GUARD_OFF_BUTTON_PRESSED"] = 4096] = "IS_FOB_GUARD_OFF_BUTTON_PRESSED";
        StatusFlags[StatusFlags["IS_FOB_GUARD_USER_BUTTON_1_PRESSED"] = 8192] = "IS_FOB_GUARD_USER_BUTTON_1_PRESSED";
        StatusFlags[StatusFlags["IS_FOB_GUARD_USER_BUTTON_2_PRESSED"] = 16384] = "IS_FOB_GUARD_USER_BUTTON_2_PRESSED";
        StatusFlags[StatusFlags["NOT_VALID_FLAG"] = 2097152] = "NOT_VALID_FLAG";
    })(StatusFlags = RadioSensor.StatusFlags || (RadioSensor.StatusFlags = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["NO_GUARD_CTRL_ENABLE"] = 1] = "NO_GUARD_CTRL_ENABLE";
        Flags[Flags["IS_OUTSIDE"] = 2] = "IS_OUTSIDE";
        Flags[Flags["MANUAL_COLOR"] = 4] = "MANUAL_COLOR";
        Flags[Flags["COLOR_BIT_1"] = 8] = "COLOR_BIT_1";
        Flags[Flags["COLOR_BIT_2"] = 16] = "COLOR_BIT_2";
        Flags[Flags["COLOR_BIT_3"] = 32] = "COLOR_BIT_3";
        Flags[Flags["COLOR_BIT_4"] = 64] = "COLOR_BIT_4";
        Flags[Flags["RADIO_EVENT_TO_SERVER_FLAG_INVERTED"] = 128] = "RADIO_EVENT_TO_SERVER_FLAG_INVERTED";
        Flags[Flags["IS_OUTSIDE_RESERVE"] = 256] = "IS_OUTSIDE_RESERVE";
    })(Flags = RadioSensor.Flags || (RadioSensor.Flags = {}));
    function isManualColor(sensor) {
        return isFlagSet(sensor, Flags.MANUAL_COLOR);
    }
    RadioSensor.isManualColor = isManualColor;
    function getColor(sensor) {
        if (!isManualColor(sensor)) {
            return 0;
        }
        return (sensor.setting_register >> 2) & 0x1f;
    }
    RadioSensor.getColor = getColor;
    function setColor(sensor, color) {
        return {
            ...sensor,
            setting_register: (sensor.setting_register & ~(0x1f << 2)) | (color << 2),
        };
    }
    RadioSensor.setColor = setColor;
    function isEventToServer(sensor) {
        return !isFlagSet(sensor, Flags.RADIO_EVENT_TO_SERVER_FLAG_INVERTED);
    }
    RadioSensor.isEventToServer = isEventToServer;
    function setEventToServer(sensor, eventToServer) {
        return setFlag(sensor, Flags.RADIO_EVENT_TO_SERVER_FLAG_INVERTED, !eventToServer);
    }
    RadioSensor.setEventToServer = setEventToServer;
    function statusFlagSet(state, flag) {
        return (state?.state_flags & flag) !== 0;
    }
    RadioSensor.statusFlagSet = statusFlagSet;
    function isActive(state) {
        return statusFlagSet(state, StatusFlags.IS_TRIGGERED_FLAG);
    }
    RadioSensor.isActive = isActive;
    function isNoConnect(state) {
        if (state?.sensor_ok == false) {
            return false;
        }
        return statusFlagSet(state, StatusFlags.NO_CONNECT_FLAG);
    }
    RadioSensor.isNoConnect = isNoConnect;
    function isLeakActive(state) {
        return statusFlagSet(state, StatusFlags.LEAK_FLAG);
    }
    RadioSensor.isLeakActive = isLeakActive;
    function isMotionActive(state) {
        return statusFlagSet(state, StatusFlags.MOTION_FLAG);
    }
    RadioSensor.isMotionActive = isMotionActive;
    function isTempTriggered(state) {
        return statusFlagSet(state, StatusFlags.IS_TEMP_TRIGGERED_FLAG);
    }
    RadioSensor.isTempTriggered = isTempTriggered;
    function isNoValidFlag(state) {
        return statusFlagSet(state, StatusFlags.NOT_VALID_FLAG);
    }
    RadioSensor.isNoValidFlag = isNoValidFlag;
    function isThermometer(sensor) {
        return [
            RadioSensor.Type.TEMPERATURE_A,
            RadioSensor.Type.TEMPERATURE_B,
            RadioSensor.Type.TEMPERATURE_C,
            RadioSensor.Type.MOTION,
            RadioSensor.Type.HUMIDITY,
            RadioSensor.Type.RADIO_DISPLAY_TEMPERATURE,
        ].includes(sensor.type);
    }
    RadioSensor.isThermometer = isThermometer;
    function isFobButtons(sensor) {
        return [
            RadioSensor.Type.RADIO_FOB_3_BUTTONS_TYPE,
            RadioSensor.Type.RADIO_FOB_4_BUTTONS_TYPE,
        ].includes(sensor.type);
    }
    RadioSensor.isFobButtons = isFobButtons;
    function filterThermometers(sensors) {
        return sensors.filter(isThermometer);
    }
    RadioSensor.filterThermometers = filterThermometers;
    function isRelaySensor(sensor) {
        return sensor.type == RadioSensor.Type.RADIO_RELAY;
    }
    RadioSensor.isRelaySensor = isRelaySensor;
    function isLeakSensor(sensor) {
        return sensor.type == RadioSensor.Type.LEAK;
    }
    RadioSensor.isLeakSensor = isLeakSensor;
    function isMotionSensor(sensor) {
        return sensor.type == RadioSensor.Type.MOTION;
    }
    RadioSensor.isMotionSensor = isMotionSensor;
    function isHumiditySensor(sensor) {
        return sensor.type == RadioSensor.Type.HUMIDITY;
    }
    RadioSensor.isHumiditySensor = isHumiditySensor;
    function isDisplayable(sensor) {
        return [
            RadioSensor.Type.LEAK,
            RadioSensor.Type.MOTION,
            RadioSensor.Type.HUMIDITY,
        ].includes(sensor.type);
    }
    RadioSensor.isDisplayable = isDisplayable;
    function isFobWithSecondAddButton(sensor) {
        return sensor.type == RadioSensor.Type.RADIO_FOB_4_BUTTONS_TYPE;
    }
    RadioSensor.isFobWithSecondAddButton = isFobWithSecondAddButton;
    function filterDisplayable(sensors) {
        return sensors.filter(isDisplayable);
    }
    RadioSensor.filterDisplayable = filterDisplayable;
    function isOutside(sensor) {
        return isFlagSet(sensor, Flags.IS_OUTSIDE);
    }
    RadioSensor.isOutside = isOutside;
    function isOutsideReserve(sensor) {
        return isFlagSet(sensor, Flags.IS_OUTSIDE_RESERVE);
    }
    RadioSensor.isOutsideReserve = isOutsideReserve;
    function setWeatherRadio(sensor, need_weather) {
        return {
            ...sensor,
            setting_register: (sensor.setting_register & ~Flags.IS_OUTSIDE) |
                (need_weather ? Flags.IS_OUTSIDE : 0),
        };
    }
    RadioSensor.setWeatherRadio = setWeatherRadio;
    function getRSSI(rawRSSI) {
        const rssi = rawRSSI;
        return rssi >= 128 ? (rssi - 256) / 2 - 73 : rssi / 2 - 73;
    }
    RadioSensor.getRSSI = getRSSI;
    function getLimits(sensor) {
        return {
            high: convertThreshold(sensor.upper_threshold),
            low: convertThreshold(sensor.lower_threshold),
        };
    }
    RadioSensor.getLimits = getLimits;
    function convertThresholds(sensor) {
        return {
            ...sensor,
            upper_threshold: convertThreshold(sensor.upper_threshold),
            lower_threshold: convertThreshold(sensor.lower_threshold),
        };
    }
    RadioSensor.convertThresholds = convertThresholds;
    function getHumidityLimits(sensor) {
        return {
            high: convertThreshold(sensor.upper_humidity_threshold),
            low: convertThreshold(sensor.lower_humidity_threshold),
        };
    }
    RadioSensor.getHumidityLimits = getHumidityLimits;
    RadioSensor.get = createAccessors(arrayGetSet('radiosensors'), {
        serial: '',
        type: 0,
        name: 'Радио',
        upper_threshold: 0,
        lower_threshold: 0,
        hysteresis: 1,
        upper_humidity_threshold: 80,
        lower_humidity_threshold: 30,
        humidity_hysteresis: 5,
        no_connection_timeout: 20,
        movement_leakage_trigger_reset_time: 1,
        rol_connection_lost: [],
        rol_temperature_upper_threshold: [],
        rol_sensor_humidity_out_thresholds: [],
        rol_movement_leakage_triggered: [],
        related_radiomodule_id: -1,
        setting_register: 1,
        rol_temperature_lower_threshold: [],
        rol_sensor_humidity_lower_thresholds: [],
        position: 0,
        calibration_shift: 0,
    });
})(RadioSensor || (RadioSensor = {}));
